<template>
  <label class="input-inside-chat-label">
    <span v-if="text">{{ text }}</span>
    <input
      :value="value"
      :placeholder="type === 'email' ? 'email@example.com' : ''"
      class="input-inside-chat"
      :class="{ error: validate.$invalid && validate.$dirty }"
      :min="minDate"
      @input="changeInput"
      @blur="onBlur"
    />
    <span v-if="type === 'email' && isDirty && validate.$dirty && !validate.email" class="red-text">
      {{ $t('validation.correct_email') }}
    </span>
    <span v-if="isDirty && validate.$dirty && !validate.integer" class="red-text">
      {{ $t('validation.invalid_integer') }}
    </span>
  </label>
</template>

<script>
export default {
  name: 'ChatInput',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    text: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    validationTrigger: {
      type: String,
      default: 'blur'
    },
    validate: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      isDirty: false
    }
  },

  computed: {
    minDate() {
      return this.type === 'date' ? new Date().toISOString().split('T')[0] : null
    }
  },

  methods: {
    changeInput($event) {
      if (this.validationTrigger === 'change') {
        this.onBlur()
      }
      this.$emit('input', $event.target.value)
    },
    onBlur() {
      this.isDirty = true
      this.validate.$touch()
    }
  }
}
</script>
